export class HhsgSharedDataImportModel {
	id: number = -1;
	corporationId: number;
	clientNames: string;
	fileName: string = '';
	s3Location: string = '';
	statusId: HhsgSharedDataImportStatus;
	dateImported: Date;
	dateCompleted: Date;
	errors: string;
	userName: string;
	corporationName: string;
	clientName: string;
	statusName: string;
}

export enum HhsgSharedDataImportStatus {
	validatingFile = 1,
	fileValidationFailed = 2,
	processing = 3,
	error = 4,
	success = 5,
	pending = 6,
	waiting = 7,
	hiaProcessing = 8
}
